<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="create-attribute-dialog"
    :open.sync="openDialog"
    :form-ref.sync="attributeFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Créer un attribut</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-select
        v-model="attributeForm.name"
        label="Nom"
        :items="attributesChoices"
        @change="updateData(attributeForm.name)"
      ></v-select>
      <v-text-field
        v-model="attributeForm.value"
        label="Valeur"
        :rules="rules.valueRules"
      ></v-text-field>
      <v-row>
        <p class="font-weight-bold" style="width: 100%">Syntaxe :</p>
        <br />
        <span v-html="syntax"></span>
      </v-row>
      <br />
      <v-row>
        <p class="font-weight-bold">Description :</p>
        <br />
        <span v-html="description" class="text-caption"></span>
      </v-row>
      <v-textarea
        v-model="attributeForm.comment"
        label="Commentaire"
      ></v-textarea>
      <p>
        Les commentaires sont utilisés pour savoir par qui et pour quelle raison
        l'attribut a été ajouté
      </p>
    </template>
    <template v-slot:[`dialog.actions.save`]>Créer</template>
  </base-dialog>
</template>
<script>
import { toRefs, ref, computed } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { attributeData, createAttribute } = useAttributes();

    /* Variables */
    const syntax = ref("");
    const description = ref("");
    const attributesChoices = attributeData.attributesChoice.sort();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const updateData = function (selected) {
      syntax.value = attributeData.attributesChoiceData[selected][1];
      description.value = attributeData.attributesChoiceData[selected][2];
    };
    const saveItem = async function () {
      await createAttribute(props.clientPortal.id);
      openDialog.value = attributeData.createAttributeDialog;
    };

    return {
      syntax,
      description,
      updateData,
      createAttribute,
      attributesChoices,
      ...toRefs(attributeData),
      saveItem,
      openDialog,
    };
  },
};
</script>
